

// common components
export { default as ChartCanvas } from "./lib/ChartCanvas";
export { default as Chart } from "./lib/Chart";
export { default as GenericChartComponent } from "./lib/GenericChartComponent";
export { default as GenericComponent } from "./lib/GenericComponent";
export { default as BackgroundText } from "./lib/BackgroundText";
export { default as ZoomButtons } from "./lib/ZoomButtons";

export const version = "0.7.7";

/*
// chart types & Series
import * as series from "./lib/series";
import * as scale from "./lib/scale";

import * as coordinates from "./lib/coordinates";
import * as indicator from "./lib/indicator";
import * as algorithm from "./lib/algorithm";

import * as annotation from "./lib/annotation";

import * as axes from "./lib/axes";
import * as tooltip from "./lib/tooltip";
import * as helper from "./lib/helper";

import * as interactive from "./lib/interactive";
import * as utils from "./lib/utils";

*/
